import {
  UPDATE_ACTIVITY_PROPERTY,
  SET_ACTIVITY_SECTION,
  SET_ACTIVITY_INFO,
  SET_PICKER_DATA,
  SET_LOADING,
  UPDATE_ACTIVITY_PROPERTIES,
  SET_SECTIONS_LOADED,
  SET_SECTIONS_LOADING,
  RESET_TEMP_DATA,
  SET_TEMP_DATA
} from '../actions/actionTypes';

const initialState = {
  data: {}
};

const activityReducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case UPDATE_ACTIVITY_PROPERTY: {
      const { section, property, value } = payload;
      return handleActivityPropertyChange(state, section, property, value);
    }
    case UPDATE_ACTIVITY_PROPERTIES: {
      const { properties } = payload;
      let latestState = state;
      properties.forEach(({ section, property, value }) => {
        latestState = handleActivityPropertyChange(latestState, section, property, value);
      });
      return latestState;
    }

    case SET_ACTIVITY_SECTION: {
      let newState = state;
      payload.forEach(({ section, data: sectionData }) => {
        newState = setSectionData(newState, section, sectionData);
      });
      return newState;
    }
    case SET_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        isLoading
      };
    }
    case SET_ACTIVITY_INFO: {
      const { activityId, activityType, data } = payload;
      // Should reset data, so that pickers data is refereshed
      return {
        isLoading: state.isLoading,
        activityId,
        activityType,
        data
      };
    }
    case SET_PICKER_DATA: {
      const { property, value } = payload;
      return {
        ...state,
        pickersData: {
          ...state.pickersData,
          [property]: value
        }
      };
    }
    case SET_SECTIONS_LOADING:
      return setSectionsLoading(state, payload);
    case SET_SECTIONS_LOADED:
      return setSectionsLoaded(state, payload);
    case SET_TEMP_DATA: {
      const { property, value } = payload;
      return {
        ...state,
        tempData: {
          ...state.pickersData,
          [property]: value
        }
      };
    }
    case RESET_TEMP_DATA:
      return {
        ...state,
        tempData: undefined
      };
    default:
      return state;
  }
};

const handleActivityPropertyChange = (state, section, property, value) => {
  const sectionsData = getNewSectionData(state, section, property, value);
  return setSectionData(state, section, sectionsData);
};
/**
 *
 * @param {Object} state
 * @param {String} section
 * @param {String} property
 * @param {*} value
 */
const getNewSectionData = (state, section, property, value) => {
  const { data } = state;
  const { [section]: sectionData } = data;
  let propertyValue = {
    [property]: value
  };
  if (section === property) {
    return value;
  }
  if (property && property.indexOf('.') !== -1) {
    const properties = property.split('.');
    let outerProperty = sectionData || {};
    propertyValue = outerProperty;
    properties.forEach((prop, index) => {
      outerProperty[prop] = outerProperty[prop] || {};
      if (index === properties.length - 1) {
        outerProperty[prop] = value;
      }
      outerProperty = outerProperty[prop];
    });
  }
  return {
    ...sectionData,
    ...propertyValue
  };
};
const setSectionData = (state, section, data) => {
  if (state.data[section] === data) {
    return state;
  }
  return setData(state, {
    ...state.data,
    [section]: data
  });
};
const setData = (state, data) => ({
  ...state,
  data
});

/**
 *
 * @param {*} state
 * @param {String[]} payload
 */
const setSectionsLoading = (state, payload) => {
  let isLoading = true;
  const { sectionsLoading = {} } = state;
  payload.forEach((section) => {
    isLoading = true;
    sectionsLoading[section] = true;
  });
  return {
    ...state,
    sectionsLoading: {
      ...sectionsLoading
    },
    isSectionsLoading: isLoading
  };
};

/**
 *
 * @param {*} state
 * @param {String[]} payload
 */
const setSectionsLoaded = (state, payload) => {
  let isLoading = false;
  const { sectionsLoading } = state;
  payload.forEach((section) => {
    sectionsLoading[section] = false;
  });
  Object.keys(sectionsLoading).forEach((s) => {
    if (sectionsLoading[s]) {
      isLoading = true;
    }
  });
  return {
    ...state,
    sectionsLoading: {
      ...sectionsLoading
    },
    isSectionsLoading: isLoading
  };
};
export default activityReducer;
